import { FC } from 'react';

const MandatoryField: FC = () => <span className="text-danger">*</span>;

export default MandatoryField;
